import { ReactNode } from 'react';

import { styles } from './styles';

interface Props {
  backgroundColor: string;
  label: string | ReactNode;
}

const StatusLabel = ({ label, backgroundColor }: Props) => {
  const classes = styles({
    backgroundColor: backgroundColor
  });
  if (!label) return null;
  return <div className={classes.root}>{label}</div>;
};

export default StatusLabel;
